import { axiosOpen, axiosSecureInstance} from "./axios";
import { VERIFY_ORGANIZATION } from "./verification-api-constant";

export const verifyOrganization = async (org_id, data) => {
    try {
        const response = await axiosSecureInstance.patch(VERIFY_ORGANIZATION(org_id), 
            data
        );
       console.log("response:", response.data)
       return {
        success: true,
        message: response.data?.message,
        data: response.data?.data, 
    };
      
    } catch (error) {
      console.log(error);
      return { success: false, message: error?.response?.data?.message};
    } 
};